import React, { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { TriangleAlertIcon } from 'lucide-react';
interface PageErrorBoundaryProps {
  children: ReactNode;
  onReset: () => void;
}
interface PageErrorBoundaryState {
  error: Error | null;
}
export class PageErrorBoundary extends Component<PageErrorBoundaryProps, PageErrorBoundaryState> {
  state: PageErrorBoundaryState = {
    error: null
  };
  static getDerivedStateFromError(error: Error): PageErrorBoundaryState {
    return {
      error
    };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Page failed to render:', error, info.componentStack);
  }
  render() {
    const {
      error
    } = this.state;
    if (!error) return this.props.children;
    return <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-white p-8 text-center shadow-soft ring-1 ring-slate-900/[0.04]" data-id="element-58" data-mp="25l4rikabxcia">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-rose-50 text-rose-500" data-id="element-59" data-mp="u3vby8ubn4m9">
          <TriangleAlertIcon className="h-6 w-6" data-id="element-60" data-mp="3ttinzvh8ipgt" />
        </span>
        <h1 className="mt-4 text-lg font-semibold text-navy" data-id="element-61" data-mp="3ts7i9q48b7n2">This page couldn't load</h1>
        <p className="mt-1 text-sm text-muted" data-id="element-62" data-mp="1o58sz0j5m5g">{error.message || 'Something went wrong.'}</p>
        <button type="button" onClick={() => {
        this.setState({
          error: null
        });
        this.props.onReset();
      }} className="mt-6 inline-flex h-10 items-center rounded-xl bg-flame px-4 text-sm font-medium text-white hover:bg-flame-dark" data-id="element-63" data-mp="3jvme1701a0ka">
          Back to dashboard
        </button>
      </div>;
  }
}